import type { Experience, ExperienceFavoriteItem } from '@/shared/api/generated/api';
import { getCardPrice } from '@/shared/helpers/experiencePrice';
import { experienceCityUrl, experienceUrl } from '@/shared/helpers/urls';
import type { Currency } from '@/shared/models/experience-price';
import { ExperienceStringTypes, stringToExperienceType } from '@/shared/models/experience-types';

export const mapExperienceToCard = (exp: Experience, favorites: ExperienceFavoriteItem[]) => {
  const city = exp.geo?.city ? exp.geo.city[0] : undefined;
  // Цена с учётом выбранной валюты отображения (иначе — базовая цена в рублях).
  const price = getCardPrice(exp);
  const favorite = favorites.findIndex((item) => item.item_id === exp.id) !== -1;

  return {
    id: exp.id,
    title: exp.title,
    tagline: exp.tagline,
    experienceType: stringToExperienceType(exp.type),
    link: experienceUrl(exp.id),
    reviewsCount: exp.is_under_sanctions ? 0 : exp.review_count,
    city: city?.name,
    cityLink: city?.slug ? experienceCityUrl(city.slug) : '',
    imageLink: exp.photos?.length ? (exp.photos[0]?.thumbnail ?? '') : '',
    imageAltText: exp.title,
    rating: exp.is_under_sanctions ? undefined : exp.rating,
    price: price?.value,
    priceFrom: price?.price_from ?? false,
    currency: price?.currency as Currency | undefined,
    unit: price?.unit_string,
    discount: price?.discount?.value,
    originalPrice: price?.discount?.original_price,
    maxPersonsRange: price?.max_persons_range,
    discountExpirationText: price?.discount?.expiration_text,
    duration: exp.duration,
    tour: exp.type === ExperienceStringTypes.TOUR,
    movementType: exp.movement_type,
    count: exp.max_persons,
    inactive: exp.status !== 'active',
    maxPersons: exp.max_persons,
    favorite,
    guideId: exp.guide.id,
    type: exp.type,
    format: exp.format,
    instantBooking: exp.instant_booking ?? false,
    paidPromotion: exp.is_paid ?? false,
    isUnderSanctions: exp.is_under_sanctions,
  };
};

export type PreparedExperience = ReturnType<typeof mapExperienceToCard>;
